import { jsxs as i, jsx as o } from "@emotion/react/jsx-runtime";
import { RightComponentContainer as D } from "./RightComponent.styled.js";
import { Icon as p } from "../../../Icon/index.js";
import { Snippet as S } from "../../../Snippet/index.js";
import { Stack as b } from "../../../Stack/index.js";
import { getColorNotice as y } from "../../../TextInput/TextInput.styled.js";
import { NumberCaretUp as U, NumberCaretDown as j } from "../../NumberInput.styled.js";
import { UnitLabel as L } from "../UnitLabel/UnitLabel.js";
import { FontAwesomeIconsPartooUsed as c, IconPrefix as m } from "../../../../types/components/icon.js";
const _ = ({
  value: t,
  success: a,
  error: s,
  warning: f,
  unit: e,
  showControls: l,
  increment: x,
  decrement: d,
  min: h,
  max: C,
  copy: g,
  copyText: I,
  copiedText: u,
  disabled: w
}) => {
  const r = typeof t == "number" ? t : parseFloat(t), n = y({
    error: s,
    warning: f,
    success: a
  });
  return /* @__PURE__ */ i(D, { disabled: w, children: [
    g && /* @__PURE__ */ o(S, { dataTrackId: "copy__textfield", copiedText: u ?? "", copyText: I ?? "", value: t, variant: "text" }),
    e && /* @__PURE__ */ o(L, { children: e }, "unit-label"),
    l && /* @__PURE__ */ i(b, { gap: "0px", style: {
      position: "relative",
      height: "56px",
      width: "18px",
      padding: "4px"
    }, justifyContent: "center", alignItems: "center", children: [
      C > r && /* @__PURE__ */ o(U, { children: /* @__PURE__ */ o(p, { onMouseDown: x, icon: [c.faCaretUp, m.SOLID], color: n, iconSize: "16px" }) }),
      h < r && /* @__PURE__ */ o(j, { children: /* @__PURE__ */ o(p, { onMouseDown: d, icon: [c.faCaretDown, m.SOLID], color: n, iconSize: "16px" }) })
    ] })
  ] });
};
export {
  _ as RightComponent
};
